/* ============================================================
   HANKY PLANTY — shared theme interactions
   Works inside Shopify Sense. Quick-add uses the real AJAX Cart
   API and re-renders Sense's <cart-drawer> via Section Rendering.
   ============================================================ */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Sticky header shrink ---------- */
  $$('.hp-header').forEach(function (header) {
    var onScroll = function () { header.classList.toggle('shrink', window.scrollY > 20); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  });

  /* ---------- Mobile nav toggle ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.hp-menubtn');
    if (btn) {
      var nav = $('.hp-mobile-nav', btn.closest('.hp-header'));
      if (nav) nav.classList.toggle('open');
    }
  });

  /* ---------- Carousel arrows (generic: button[data-hp-rail]) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-hp-rail-dir]');
    if (!b) return;
    var railSel = b.getAttribute('data-hp-rail');
    var rail = railSel ? document.querySelector(railSel) : b.closest('section').querySelector('.hp-rail, .hp-qrail');
    if (!rail) return;
    var card = rail.querySelector('.hp-card, .hp-quote');
    var step = (card ? card.offsetWidth : 280) + 22;
    rail.scrollBy({ left: step * parseInt(b.getAttribute('data-hp-rail-dir'), 10), behavior: 'smooth' });
  });

  /* ---------- Routine tabs ---------- */
  $$('[data-hp-routine]').forEach(function (root) {
    root.addEventListener('click', function (e) {
      var b = e.target.closest('.hp-rstep');
      if (!b) return;
      $$('.hp-rstep', root).forEach(function (s) { s.setAttribute('aria-selected', s === b); });
      var i = b.getAttribute('data-step');
      $$('.hp-rpane', root).forEach(function (p) {
        if (p.getAttribute('data-pane') === i) p.setAttribute('data-active', '');
        else p.removeAttribute('data-active');
      });
    });
  });

  /* ---------- Reveal on scroll ----------
     IntersectionObserver gives the nice staggered effect, but we back it
     with a scroll/resize check + a load failsafe so content can never get
     stuck invisible if the observer is throttled or never fires. */
  (function () {
    var reveals = $$('.hp-reveal');
    if (!reveals.length) return;

    function revealInView() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      reveals = reveals.filter(function (el) {
        if (el.classList.contains('in')) return false;
        var top = el.getBoundingClientRect().top;
        if (top < vh * 0.92) { el.classList.add('in'); return false; }
        return true;
      });
      if (!reveals.length) {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', revealInView);
      }
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { revealInView(); ticking = false; });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
        });
      }, { threshold: 0.12 });
      reveals.forEach(function (el) { io.observe(el); });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', revealInView);
    revealInView();
    // Ultimate failsafe: never leave anything hidden after full load.
    window.addEventListener('load', function () {
      setTimeout(function () { $$('.hp-reveal:not(.in)').forEach(function (el) {
        var top = el.getBoundingClientRect().top;
        if (top < (window.innerHeight || 0)) el.classList.add('in');
      }); revealInView(); }, 500);
    });
  })();

  /* ---------- Rotary seal render ---------- */
  $$('[data-hp-seal]').forEach(function (el) {
    var text = el.getAttribute('data-hp-seal') || 'HANKY PLANTY · BATH & BEAUTY · GROWN IN MALAYSIA · ';
    var uid = 'hp-sealpath-' + Math.random().toString(36).slice(2);
    el.innerHTML =
      '<svg viewBox="0 0 200 200" class="hp-seal__spin">' +
      '<defs><path id="' + uid + '" d="M100,100 m-74,0 a74,74 0 1,1 148,0 a74,74 0 1,1 -148,0"/></defs>' +
      '<text><textPath href="#' + uid + '" startOffset="0">' + text + text + '</textPath></text></svg>' +
      '<span class="hp-seal__center"><span class="hp-leaf"></span></span>';
  });

  /* ---------- Toast ---------- */
  var toastT;
  function toast(msg) {
    var t = $('#hp-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'hp-toast';
      t.className = 'hp-toast';
      t.innerHTML = '<span class="hp-leaf"></span><span id="hp-toast-msg"></span>';
      document.body.appendChild(t);
    }
    $('#hp-toast-msg', t).textContent = msg;
    t.classList.add('show');
    clearTimeout(toastT);
    toastT = setTimeout(function () { t.classList.remove('show'); }, 1900);
  }

  /* ---------- Quick-add → real Shopify cart + Sense drawer ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-hp-add]');
    if (!btn) return;
    e.preventDefault();
    var variantId = btn.getAttribute('data-hp-add');
    if (!variantId) return;
    btn.setAttribute('disabled', 'disabled');
    var original = btn.textContent;
    btn.textContent = 'Adding…';

    var cartDrawer = document.querySelector('cart-drawer');
    var body = {
      items: [{ id: parseInt(variantId, 10), quantity: 1 }]
    };
    if (cartDrawer) {
      body.sections = 'cart-drawer,cart-icon-bubble';
      body.sections_url = window.location.pathname;
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { toast(res.description || 'Could not add to basket'); return; }
        toast('Added to basket');
        if (cartDrawer && res.sections) {
          cartDrawer.classList.remove('is-empty');
          cartDrawer.renderContents(res);
          refreshCartCount();
        } else {
          // No drawer on this template — bump the bubble count
          refreshCartCount();
        }
      })
      .catch(function () { toast('Could not add to basket'); })
      .finally(function () {
        btn.removeAttribute('disabled');
        btn.textContent = original;
      });
  });

  // Sense re-renders #cart-icon-bubble on every cart change, wiping our custom
  // leaf icon. Restore our markup (icon + count) so the header stays on-brand.
  function restoreCartIcon(count) {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    bubble.innerHTML =
      '<svg><use href="#hp-cart"></use></svg>' +
      '<span class="hp-cartcount">' + (count > 0 ? count : '') + '</span>';
  }

  function refreshCartCount() {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { restoreCartIcon(cart.item_count); });
  }
  refreshCartCount();

  /* ---------- Product gallery: thumbnail → main image swap ---------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-hp-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-hp-gallery]');
    var main = gallery && gallery.querySelector('.hp-mainimg img');
    if (main) main.src = thumb.getAttribute('data-hp-thumb');
    $$('.hp-thumb', gallery).forEach(function (t) { t.classList.toggle('active', t === thumb); });
  });

  /* ---------- Product: qty stepper ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-hp-qty]');
    if (!b) return;
    var input = b.parentNode.querySelector('input[name="quantity"]');
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    v += parseInt(b.getAttribute('data-hp-qty'), 10);
    if (v < 1) v = 1;
    input.value = v;
  });

  /* ---------- Product: single-option variant pills (direct id) ---------- */
  $$('.hp-product-form').forEach(function (form) {
    var directPills = $$('.hp-sizepill[data-hp-variant]', form);
    if (!directPills.length) return;
    var select = form.querySelector('[data-hp-variant-select]');
    form.addEventListener('click', function (e) {
      var pill = e.target.closest('.hp-sizepill[data-hp-variant]');
      if (!pill || pill.hasAttribute('disabled')) return;
      directPills.forEach(function (p) { p.classList.toggle('active', p === pill); });
      if (select) select.value = pill.getAttribute('data-hp-variant');
      var price = pill.getAttribute('data-hp-price');
      var compare = pill.getAttribute('data-hp-compare');
      $$('[data-hp-price]', form.closest('.hp-buybox')).forEach(function (el) {
        el.innerHTML = (compare ? '<s>' + compare + '</s> ' : '') + price;
      });
      var onetime = form.querySelector('[data-hp-onetime]');
      if (onetime) onetime.textContent = price;
    });
  });

  /* ---------- Product: variant pills → update select + price ---------- */
  $$('.hp-product-form').forEach(function (form) {
    var select = form.querySelector('[data-hp-variant-select]');
    if (!select || $$('.hp-sizepill[data-hp-variant]', form).length) return;
    var chosen = {};
    // seed from selected variant
    $$('.hp-sizepills', form).forEach(function (group) {
      var active = group.querySelector('.hp-sizepill.active');
      var pos = active ? active.getAttribute('data-hp-option') : group.querySelector('.hp-sizepill').getAttribute('data-hp-option');
      chosen[pos] = active ? active.getAttribute('data-hp-value') : group.querySelector('.hp-sizepill').getAttribute('data-hp-value');
    });

    form.addEventListener('click', function (e) {
      var pill = e.target.closest('.hp-sizepill');
      if (!pill) return;
      var pos = pill.getAttribute('data-hp-option');
      chosen[pos] = pill.getAttribute('data-hp-value');
      // toggle active within the group
      var group = pill.closest('.hp-sizepills');
      $$('.hp-sizepill', group).forEach(function (p) { p.classList.toggle('active', p === pill); });
      // find matching variant option
      var opts = [];
      $$('.hp-sizepills', form).forEach(function (g) {
        var a = g.querySelector('.hp-sizepill.active');
        var p = a ? a.getAttribute('data-hp-option') : g.querySelector('.hp-sizepill').getAttribute('data-hp-option');
        opts[p] = a ? a.getAttribute('data-hp-value') : g.querySelector('.hp-sizepill').getAttribute('data-hp-value');
      });
      var match = Array.prototype.slice.call(select.options).filter(function (o) {
        return (!o.getAttribute('data-hp-opt1') || o.getAttribute('data-hp-opt1') === (opts[1] || '')) &&
               (o.getAttribute('data-hp-opt2') === 'null' || !o.getAttribute('data-hp-opt2') || o.getAttribute('data-hp-opt2') === (opts[2] || '')) &&
               (o.getAttribute('data-hp-opt3') === 'null' || !o.getAttribute('data-hp-opt3') || o.getAttribute('data-hp-opt3') === (opts[3] || ''));
      })[0];
      if (match) {
        select.value = match.value;
        var price = match.getAttribute('data-hp-price');
        var compare = match.getAttribute('data-hp-compare');
        $$('[data-hp-price]', form).forEach(function (el) {
          el.innerHTML = (compare ? '<s>' + compare + '</s> ' : '') + price;
        });
        $$('.hp-buybox [data-hp-price]').forEach(function (el) {
          if (!form.contains(el)) el.innerHTML = (compare ? '<s>' + compare + '</s> ' : '') + price;
        });
      }
    });
  });

  /* ---------- Product form submit → AJAX add + open Sense drawer ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.hp-product-form');
    if (!form) return;
    e.preventDefault();
    var submitBtn = form.querySelector('[type="submit"]');
    var label = submitBtn && submitBtn.querySelector('span');
    var original = label ? label.textContent : '';
    if (label) label.textContent = 'Adding…';
    if (submitBtn) submitBtn.setAttribute('disabled', 'disabled');

    var cartDrawer = document.querySelector('cart-drawer');
    var formData = new FormData(form);
    var item = { id: parseInt(formData.get('id'), 10), quantity: parseInt(formData.get('quantity'), 10) || 1 };
    var sellingPlan = formData.get('selling_plan');
    if (sellingPlan) item.selling_plan = parseInt(sellingPlan, 10);
    var body = { items: [item] };
    if (cartDrawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { toast(res.description || 'Could not add to basket'); return; }
        toast('Added to basket');
        if (cartDrawer && res.sections) { cartDrawer.classList.remove('is-empty'); cartDrawer.renderContents(res); }
        refreshCartCount();
      })
      .catch(function () { toast('Could not add to basket'); })
      .finally(function () {
        if (label) label.textContent = original;
        if (submitBtn) submitBtn.removeAttribute('disabled');
      });
  });

  /* ---------- Collection: view toggle (2 / 4 col), persisted ---------- */
  (function () {
    var viewWrap = $('[data-hp-view]');
    var grid = $('[data-hp-grid]');
    if (!viewWrap || !grid) return;
    function applyView(v) {
      grid.classList.remove('view-2', 'view-4');
      if (v === '2') grid.classList.add('view-2');
      if (v === '4') grid.classList.add('view-4');
      $$('.hp-viewbtn', viewWrap).forEach(function (b) { b.classList.toggle('active', b.getAttribute('data-view') === v); });
      try { localStorage.setItem('hp_view', v); } catch (e) {}
    }
    viewWrap.addEventListener('click', function (e) {
      var b = e.target.closest('.hp-viewbtn');
      if (b) applyView(b.getAttribute('data-view'));
    });
    var saved;
    try { saved = localStorage.getItem('hp_view'); } catch (e) {}
    if (saved) applyView(saved);
  })();

  /* ---------- Hero video reel ---------- */
  function initReel(reel) {
    if (reel.hasAttribute('data-hp-reel-ready')) return;
    reel.setAttribute('data-hp-reel-ready', '');
    var slides = $$('.hp-hero__slide', reel);
    var dots = $$('[data-hp-reel-dot]', reel);
    if (slides.length < 1) return;
    var idx = 0;

    function playActive() {
      slides.forEach(function (s, i) {
        var v = s.querySelector('video');
        if (!v) return;
        if (i === idx) { try { v.currentTime = 0; v.play(); } catch (e) {} }
        else { try { v.pause(); } catch (e) {} }
      });
    }
    function go(n) {
      idx = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('active', i === idx); });
      dots.forEach(function (d, i) { d.classList.toggle('active', i === idx); });
      playActive();
    }

    reel.addEventListener('click', function (e) {
      var arrow = e.target.closest('[data-hp-reel-dir]');
      if (arrow) { go(idx + parseInt(arrow.getAttribute('data-hp-reel-dir'), 10)); return; }
      var dot = e.target.closest('[data-hp-reel-dot]');
      if (dot) { go(parseInt(dot.getAttribute('data-hp-reel-dot'), 10)); }
    });

    // Touch swipe
    var startX = null;
    reel.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    reel.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) go(idx + (dx < 0 ? 1 : -1));
      startX = null;
    });

    // Advance to next when a video finishes (so the reel auto-browses)
    slides.forEach(function (s) {
      var v = s.querySelector('video');
      if (v) { v.loop = false; v.addEventListener('ended', function () { go(idx + 1); }); }
    });

    playActive();
  }
  $$('[data-hp-hero-reel]').forEach(initReel);

  /* Re-init the reel when the Shopify theme editor re-renders a section. */
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-hp-hero-reel]', e.target).forEach(initReel);
  });

  /* ---------- Build Your Own Bundle ---------- */
  $$('[data-hp-bundle]').forEach(function (root) {
    var min = parseInt(root.getAttribute('data-min'), 10) || 3;
    var discount = parseInt(root.getAttribute('data-discount'), 10) || 0;
    var code = root.getAttribute('data-code') || '';
    var bar = root.querySelector('[data-hp-bundle-bar]');
    var sel = {}; // variantId -> { qty, price, title }

    function money(cents) {
      var s = (cents / 100).toFixed(2).replace(/\.00$/, '');
      return (window.Shopify && Shopify.currency ? 'RM' : 'RM') + s;
    }
    function totals() {
      var count = 0, subtotal = 0;
      Object.keys(sel).forEach(function (id) { count += sel[id].qty; subtotal += sel[id].qty * sel[id].price; });
      return { count: count, subtotal: subtotal };
    }
    function render() {
      var t = totals();
      if (bar) bar.hidden = t.count === 0;
      var cntEl = root.querySelector('[data-hp-bundle-total-count]');
      if (cntEl) cntEl.textContent = t.count;
      var sub = root.querySelector('[data-hp-bundle-subtotal]');
      var saveEl = root.querySelector('[data-hp-bundle-save]');
      var cta = root.querySelector('[data-hp-bundle-add]');
      var ctaLabel = root.querySelector('[data-hp-bundle-cta-label]');
      var qualifies = t.count >= min;
      if (sub) {
        if (qualifies && discount > 0) {
          var discounted = Math.round(t.subtotal * (1 - discount / 100));
          sub.innerHTML = '<s style="color:var(--hp-ink-soft);font-weight:400;font-size:14px">' + money(t.subtotal) + '</s> ' + money(discounted);
        } else {
          sub.textContent = money(t.subtotal);
        }
      }
      if (saveEl) {
        saveEl.hidden = !(qualifies && discount > 0);
        saveEl.textContent = 'Save ' + discount + '%';
      }
      if (cta) cta.disabled = !qualifies;
      if (ctaLabel) ctaLabel.textContent = qualifies ? 'Add bundle to basket' : (min - t.count) + ' more to save ' + discount + '%';
    }

    root.addEventListener('click', function (e) {
      var card = e.target.closest('.hp-bundle__card');
      if (!card) return;
      var id = card.getAttribute('data-variant');
      var price = parseInt(card.getAttribute('data-price'), 10);
      if (e.target.closest('.hp-bundle__toggle')) {
        sel[id] = { qty: 1, price: price, title: card.getAttribute('data-title') };
        card.classList.add('selected');
      } else if (e.target.closest('[data-hp-bundle-inc]')) {
        if (sel[id]) sel[id].qty++;
      } else if (e.target.closest('[data-hp-bundle-dec]')) {
        if (sel[id]) { sel[id].qty--; if (sel[id].qty <= 0) { delete sel[id]; card.classList.remove('selected'); } }
      } else { return; }
      var cnt = card.querySelector('[data-hp-bundle-count]');
      if (cnt && sel[id]) cnt.textContent = sel[id].qty;
      render();
    });

    var addBtn = root.querySelector('[data-hp-bundle-add]');
    if (addBtn) addBtn.addEventListener('click', function () {
      var items = Object.keys(sel).map(function (id) { return { id: parseInt(id, 10), quantity: sel[id].qty }; });
      if (!items.length) return;
      addBtn.disabled = true;
      var label = root.querySelector('[data-hp-bundle-cta-label]');
      var prev = label ? label.textContent : '';
      if (label) label.textContent = 'Adding…';
      var cartDrawer = document.querySelector('cart-drawer');
      var body = { items: items };
      if (cartDrawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
      var applyCode = code
        ? fetch(window.Shopify.routes.root.replace(/\/$/, '') + '/discount/' + encodeURIComponent(code)).catch(function () {})
        : Promise.resolve();
      applyCode.then(function () {
        return fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
        });
      }).then(function (r) { return r.json(); }).then(function (res) {
        if (res.status) { toast(res.description || 'Could not add bundle'); return; }
        toast('Bundle added' + (discount ? ' · ' + discount + '% off' : ''));
        if (cartDrawer && res.sections) { cartDrawer.classList.remove('is-empty'); cartDrawer.renderContents(res); }
        refreshCartCount();
      }).catch(function () { toast('Could not add bundle'); })
      .finally(function () { addBtn.disabled = false; if (label) label.textContent = prev; });
    });

    render();
  });

  /* ---------- Accordion (ingredients / FAQs) ---------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.hp-acc__trigger');
    if (!trigger) return;
    var item = trigger.closest('.hp-acc__item');
    if (!item) return;
    var open = item.classList.toggle('open');
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---------- About: count-up numbers ---------- */
  $$('[data-hp-numbers]').forEach(function (grid) {
    var cells = $$('[data-hp-count]', grid);
    var done = false;
    function run() {
      if (done) return;
      done = true;
      cells.forEach(function (cell) {
        var target = parseInt(cell.getAttribute('data-hp-count'), 10) || 0;
        var prefix = cell.getAttribute('data-hp-prefix') || '';
        var suffix = cell.getAttribute('data-hp-suffix') || '';
        var start = null, dur = 1400;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          cell.textContent = prefix + Math.round(target * eased).toLocaleString() + suffix;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting) { run(); io.disconnect(); } }); }, { threshold: 0.3 });
      io.observe(grid);
    }
    // Failsafe: run when scrolled into view even if IO is throttled.
    window.addEventListener('scroll', function () {
      if (!done && grid.getBoundingClientRect().top < (window.innerHeight || 0) * 0.85) run();
    }, { passive: true });
    if (grid.getBoundingClientRect().top < (window.innerHeight || 0)) run();
  });

  /* ---------- Newsletter inline validation (native Shopify form still posts) ---------- */
  $$('.hp-newsform').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var input = form.querySelector('input[type="email"]');
      var err = form.querySelector('.hp-news__err');
      if (input && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(input.value.trim())) {
        e.preventDefault();
        if (err) err.textContent = 'Please enter a valid email address.';
      }
    });
  });
})();
